<script>
export default {
  name:'pages',
    props: {
        pageCount:Number,
        pages:Array,
        currentPage:Number,
    },
    mounted () {
    },
    render(h) {
        var page = _.filter(this.$slots.default,(c)=>{
            if(c.componentOptions && c.componentOptions.tag == 'page'
            && c.componentOptions.propsData.number == this.currentPage)
                return true
        })
        var other = _.filter(this.$slots.default,(c)=>{
            if(c.componentOptions && c.componentOptions.tag !== 'page')
                return true
        })
        if(this.$slots['page_'+this.currentPage]) page.push(this.$slots['page_'+this.currentPage])
        // page = h('page',{props:{number:this.currentPage}},[this.$slots.default,this.$slots['page_'+this.currentPage]])
        return h('div',[this.pageNav(h),page])
    },
    computed:{

    },
    methods:{
        pageNav(h){
            var pages = []
            var name = this.$route.name
            if(this.pageCount)
            for (var i = 1; i <= this.pageCount; i++) {
                var params = _.clone(this.$route.params)
                params.page = i
                var page = h('router-link', { class: 'btn btn-sm btn-secondary w-100 p-0', props:{ to:{name,params} }},[i]);
                pages.push(page)
            };
            if(this.pages)
            _.each(this.pages, (p)=> {
                var params = _.clone(this.$route.params)
                params.page = p.number
                var page = h('router-link', {
                    class: ['btn btn-sm btn-secondary w-100 p-0',p.hasError ? 'btn-outline-danger':'btn-outline-success',{'disabled':!p.canProgressToPage}],
                    props:{ to:{name,params} }
                },
                [p.number]);
                pages.push(page)
            });        
            return h('btn-group',{class:['mb-4 pages'],props:{justified:true}},pages)
        }
    },
}
</script>
<style lang="scss">
    .nav-link{
        padding:2px;
    }
</style>